import { useState } from "react";
import { AddPolicyButton } from "./components/AddPolicyButton";
import { PolicyCreationDialog } from "./components/PolicyCreationDialog";

interface PolicyCreationFormProps {
  userId: string;
  onPolicyCreated: () => void;
}

export const PolicyCreationForm = ({ userId, onPolicyCreated }: PolicyCreationFormProps) => {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <AddPolicyButton onClick={() => setShowDialog(true)} />
      <PolicyCreationDialog
        userId={userId}
        open={showDialog}
        onOpenChange={setShowDialog}
        onPolicyCreated={onPolicyCreated}
      />
    </>
  );
};